<div class="p-6 container">
    <div class="flex flex-col sm:flex-row gap-4">
      <div class="card overflow-hidden flex-auto">
        <div class="px-6 py-4 border-b flex items-center">
          <h2 class="title m-0">Connection</h2>
        </div>
  
        <div class="px-6 py-4 flex flex-col">

          <h1>Good one Butch! The cooooooode:</h1>

          <h2>{{ code }}&nbsp;<button
            (click)="copyToClipboard()"
            mat-icon-button
            matIconSuffix
            matTooltip="Copy to clipboard bitch!"
            type="button"
          >
            <mat-icon svgIcon="mat:file_copy"></mat-icon>
          </button></h2>

          <br><br>

            <mat-form-field>
                <mat-label>Channel</mat-label>
            <mat-select (selectionChange)="selectChannel($event)">
                <mat-option
                *ngFor="let channel of channels"
                [value]="channel">
                <span class="flex items-center">
                  <img
                    [src]="channel.avatarUrl"
                    class="align-middle mr-4 shadow-lg inline-block avatar" />
                  <span class="flex flex-col">
                    <span class="body-1 leading-snug">{{ channel.name }} </span>
                    <span class="caption text-secondary leading-none"
                    >(ID: {{ channel.externalId }})</span
                    >
                  </span>
                </span>
              </mat-option>
            </mat-select>
            </mat-form-field>

          
        </div>
      </div>
    </div>
  
    